export const unilendV2coreABI = [
  {
    inputs: [
      { internalType: 'address', name: '_poolMasterAddress', type: 'address' },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: '_target',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: '_reserve',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'int256',
        name: '_amount',
        type: 'int256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: '_totalFee',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: '_protocolFee',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: '_timestamp',
        type: 'uint256',
      },
    ],
    name: 'FlashLoan',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: '_address',
        type: 'address',
      },
    ],
    name: 'NewDefaultInterestRateAddress',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: 'uint8', name: '_ltv', type: 'uint8' },
      { indexed: false, internalType: 'uint8', name: '_lb', type: 'uint8' },
      { indexed: false, internalType: 'uint8', name: '_rf', type: 'uint8' },
    ],
    name: 'NewDefaultMarketConfig',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: '_address',
        type: 'address',
      },
    ],
    name: 'NewGovernorAddress',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: '_address',
        type: 'address',
      },
    ],
    name: 'NewOracleAddress',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: '_address',
        type: 'address',
      },
    ],
    name: 'NewPositionAddress',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'token0',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'token1',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'pool',
        type: 'address',
      },
      { indexed: false, internalType: 'uint256', name: '', type: 'uint256' },
    ],
    name: 'PoolCreated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'token',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'pool',
        type: 'address',
      },
      { indexed: false, internalType: 'uint256', name: '', type: 'uint256' },
    ],
    name: 'PoolCreated',
    type: 'event',
  },
  {
    inputs: [],
    name: 'defaultInterestRate',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [],
    name: 'distributorAddress',
    outputs: [{ internalType: 'address payable', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [
      { internalType: 'address', name: '', type: 'address' },
      { internalType: 'address', name: '', type: 'address' },
    ],
    name: 'getPool',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [],
    name: 'governor',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [],
    name: 'oracleAddress',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [],
    name: 'poolLength',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [],
    name: 'poolMasterAddress',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [],
    name: 'positionsAddress',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  { stateMutability: 'payable', type: 'receive', payable: true },
  {
    inputs: [],
    name: 'getFlashLoanFeesInBips',
    outputs: [
      { internalType: 'uint256', name: '', type: 'uint256' },
      { internalType: 'uint256', name: '', type: 'uint256' },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [
      { internalType: 'address', name: '_token0', type: 'address' },
      { internalType: 'address', name: '_token1', type: 'address' },
      { internalType: 'uint256', name: '_amount', type: 'uint256' },
    ],
    name: 'getOraclePrice',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [{ internalType: 'address', name: '_pool', type: 'address' }],
    name: 'getPoolLTV',
    outputs: [{ internalType: 'uint256', name: '_ltv', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [{ internalType: 'address', name: '_pool', type: 'address' }],
    name: 'getPoolTokens',
    outputs: [
      { internalType: 'address', name: '', type: 'address' },
      { internalType: 'address', name: '', type: 'address' },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [
      { internalType: 'address', name: '_token0', type: 'address' },
      { internalType: 'address', name: '_token1', type: 'address' },
    ],
    name: 'getPoolByTokens',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [
      { internalType: 'address', name: '_pool', type: 'address' },
      { internalType: 'address', name: '_address', type: 'address' },
    ],
    name: 'balanceOfUserToken0',
    outputs: [
      { internalType: 'uint256', name: '_lendBalance0', type: 'uint256' },
      { internalType: 'uint256', name: '_borrowBalance0', type: 'uint256' },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [
      { internalType: 'address', name: '_pool', type: 'address' },
      { internalType: 'address', name: '_address', type: 'address' },
    ],
    name: 'balanceOfUserToken1',
    outputs: [
      { internalType: 'uint256', name: '_lendBalance1', type: 'uint256' },
      { internalType: 'uint256', name: '_borrowBalance1', type: 'uint256' },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [
      { internalType: 'address', name: '_pool', type: 'address' },
      { internalType: 'address', name: '_address', type: 'address' },
    ],
    name: 'balanceOfUserTokens',
    outputs: [
      { internalType: 'uint256', name: '_lendBalance0', type: 'uint256' },
      { internalType: 'uint256', name: '_borrowBalance0', type: 'uint256' },
      { internalType: 'uint256', name: '_lendBalance1', type: 'uint256' },
      { internalType: 'uint256', name: '_borrowBalance1', type: 'uint256' },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [
      { internalType: 'address', name: '_pool', type: 'address' },
      { internalType: 'address', name: '_address', type: 'address' },
    ],
    name: 'shareOfUserToken0',
    outputs: [
      { internalType: 'uint256', name: '_lendShare0', type: 'uint256' },
      { internalType: 'uint256', name: '_borrowShare0', type: 'uint256' },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [
      { internalType: 'address', name: '_pool', type: 'address' },
      { internalType: 'address', name: '_address', type: 'address' },
    ],
    name: 'shareOfUserToken1',
    outputs: [
      { internalType: 'uint256', name: '_lendShare1', type: 'uint256' },
      { internalType: 'uint256', name: '_borrowShare1', type: 'uint256' },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [
      { internalType: 'address', name: '_pool', type: 'address' },
      { internalType: 'address', name: '_address', type: 'address' },
    ],
    name: 'shareOfUserTokens',
    outputs: [
      { internalType: 'uint256', name: '_lendShare0', type: 'uint256' },
      { internalType: 'uint256', name: '_borrowShare0', type: 'uint256' },
      { internalType: 'uint256', name: '_lendShare1', type: 'uint256' },
      { internalType: 'uint256', name: '_borrowShare1', type: 'uint256' },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [
      { internalType: 'address', name: '_pool', type: 'address' },
      { internalType: 'address', name: '_address', type: 'address' },
    ],
    name: 'getUserHealthFactor',
    outputs: [
      { internalType: 'uint256', name: '_healthFactor0', type: 'uint256' },
      { internalType: 'uint256', name: '_healthFactor1', type: 'uint256' },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [{ internalType: 'address', name: '_pool', type: 'address' }],
    name: 'getPoolAvailableLiquidity',
    outputs: [
      { internalType: 'uint256', name: '_token0Liquidity', type: 'uint256' },
      { internalType: 'uint256', name: '_token1Liquidity', type: 'uint256' },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [
      { internalType: 'uint8', name: '_ltv', type: 'uint8' },
      { internalType: 'uint8', name: '_lb', type: 'uint8' },
      { internalType: 'uint8', name: '_rf', type: 'uint8' },
    ],
    name: 'setDefaultMarketConfig',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: '_pool', type: 'address' },
      { internalType: 'uint8', name: '_number', type: 'uint8' },
    ],
    name: 'setPoolLTV',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: '_pool', type: 'address' },
      { internalType: 'uint8', name: '_number', type: 'uint8' },
    ],
    name: 'setPoolLB',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: '_pool', type: 'address' },
      { internalType: 'uint8', name: '_number', type: 'uint8' },
    ],
    name: 'setPoolRF',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: '_pool', type: 'address' },
      { internalType: 'address', name: '_address', type: 'address' },
    ],
    name: 'setPoolInterestRateAddress',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: '_address', type: 'address' }],
    name: 'setDefaultInterestRateAddress',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: '_address', type: 'address' }],
    name: 'setGovernor',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: '_address', type: 'address' }],
    name: 'setPositionAddress',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: '_address', type: 'address' }],
    name: 'setOracleAddress',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address payable', name: '_address', type: 'address' },
    ],
    name: 'setDistributorAddress',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256', name: '_newFeeTotal', type: 'uint256' },
      { internalType: 'uint256', name: '_newFeeProtocol', type: 'uint256' },
    ],
    name: 'setFlashLoanFeesInBips',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: '_receiver', type: 'address' },
      { internalType: 'address', name: '_pool', type: 'address' },
      { internalType: 'int256', name: '_amount', type: 'int256' },
      { internalType: 'bytes', name: '_params', type: 'bytes' },
    ],
    name: 'flashLoan',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: '_pool', type: 'address' },
      { internalType: 'int256', name: '_amount', type: 'int256' },
    ],
    name: 'lend',
    outputs: [
      { internalType: 'uint256', name: 'mintedTokens', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: '_pool', type: 'address' },
      { internalType: 'int256', name: '_token_amount', type: 'int256' },
      { internalType: 'address', name: '_receiver', type: 'address' },
    ],
    name: 'redeem',
    outputs: [{ internalType: 'int256', name: 'redeemTokens', type: 'int256' }],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: '_pool', type: 'address' },
      { internalType: 'int256', name: '_amount', type: 'int256' },
      { internalType: 'address', name: '_receiver', type: 'address' },
    ],
    name: 'redeemUnderlying',
    outputs: [
      { internalType: 'int256', name: '_token_amount', type: 'int256' },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: '_pool', type: 'address' },
      { internalType: 'int256', name: '_amount', type: 'int256' },
      { internalType: 'uint256', name: '_collateral_amount', type: 'uint256' },
      { internalType: 'address payable', name: '_recipient', type: 'address' },
    ],
    name: 'borrow',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: '_pool', type: 'address' },
      { internalType: 'int256', name: '_amount', type: 'int256' },
      { internalType: 'address', name: '_for', type: 'address' },
    ],
    name: 'repay',
    outputs: [{ internalType: 'int256', name: '_retAmount', type: 'int256' }],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: '_pool', type: 'address' },
      { internalType: 'address', name: '_for', type: 'address' },
      { internalType: 'int256', name: '_amount', type: 'int256' },
      { internalType: 'address', name: '_receiver', type: 'address' },
      { internalType: 'bool', name: 'uPosition', type: 'bool' },
    ],
    name: 'liquidate',
    outputs: [{ internalType: 'int256', name: 'payAmount', type: 'int256' }],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: '_pool', type: 'address' },
      { internalType: 'uint256[]', name: '_nftIDs', type: 'uint256[]' },
      { internalType: 'int256[]', name: '_amounts', type: 'int256[]' },
      { internalType: 'address', name: '_receiver', type: 'address' },
      { internalType: 'bool', name: 'uPosition', type: 'bool' },
    ],
    name: 'liquidateMulti',
    outputs: [{ internalType: 'int256', name: 'payAmount', type: 'int256' }],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: '_tokenA', type: 'address' },
      { internalType: 'address', name: '_tokenB', type: 'address' },
    ],
    name: 'createPool',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'nonpayable',
    type: 'function',
  },
];

export const unilendV2poolABI = [
  { inputs: [], stateMutability: 'nonpayable', type: 'constructor' },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: '_asset',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: '_positionID',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: '_amount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'totalBorrows',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'address',
        name: '_recipient',
        type: 'address',
      },
    ],
    name: 'Borrow',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: '_newRate0',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: '_newRate1',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'totalBorrows0',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'totalBorrows1',
        type: 'uint256',
      },
    ],
    name: 'InterestUpdate',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: '_asset',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: '_positionID',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: '_amount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: '_token_amount',
        type: 'uint256',
      },
    ],
    name: 'Lend',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: '_asset',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: '_positionID',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: '_toPositionID',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'repayAmount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'seizeTokens',
        type: 'uint256',
      },
    ],
    name: 'LiquidateBorrow',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: '_positionID',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: '_price',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: '_last_price',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: '_amount',
        type: 'uint256',
      },
    ],
    name: 'LiquidationPriceUpdate',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'oldLB',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'newLB',
        type: 'uint256',
      },
    ],
    name: 'NewLB',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'oldLTV',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'newLTV',
        type: 'uint256',
      },
    ],
    name: 'NewLTV',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'oldInterestRateModel',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'newInterestRateModel',
        type: 'address',
      },
    ],
    name: 'NewMarketInterestRateModel',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'oldRF',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'newRF',
        type: 'uint256',
      },
    ],
    name: 'NewRF',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: '_asset',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: '_positionID',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: '_token_amount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: '_amount',
        type: 'uint256',
      },
    ],
    name: 'Redeem',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: '_asset',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: '_positionID',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: '_amount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'totalBorrows',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'address',
        name: '_payer',
        type: 'address',
      },
    ],
    name: 'RepayBorrow',
    type: 'event',
  },
  {
    inputs: [],
    name: 'HEALTH_FACTOR_LIQUIDATION_THRESHOLD',
    outputs: [{ internalType: 'uint64', name: '', type: 'uint64' }],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [],
    name: 'core',
    outputs: [{ internalType: 'address payable', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [],
    name: 'interestRateAddress',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [],
    name: 'lastUpdated',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    name: 'positionData',
    outputs: [
      { internalType: 'uint256', name: 'token0lendShare', type: 'uint256' },
      { internalType: 'uint256', name: 'token1lendShare', type: 'uint256' },
      { internalType: 'uint256', name: 'token0borrowShare', type: 'uint256' },
      { internalType: 'uint256', name: 'token1borrowShare', type: 'uint256' },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [],
    name: 'token0',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [],
    name: 'token0Data',
    outputs: [
      { internalType: 'uint256', name: 'totalLendShare', type: 'uint256' },
      { internalType: 'uint256', name: 'totalBorrowShare', type: 'uint256' },
      { internalType: 'uint256', name: 'totalBorrow', type: 'uint256' },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [],
    name: 'token1',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [],
    name: 'token1Data',
    outputs: [
      { internalType: 'uint256', name: 'totalLendShare', type: 'uint256' },
      { internalType: 'uint256', name: 'totalBorrowShare', type: 'uint256' },
      { internalType: 'uint256', name: 'totalBorrow', type: 'uint256' },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [
      { internalType: 'address', name: '_token0', type: 'address' },
      { internalType: 'address', name: '_token1', type: 'address' },
      { internalType: 'address', name: '_interestRate', type: 'address' },
      { internalType: 'uint8', name: '_ltv', type: 'uint8' },
      { internalType: 'uint8', name: '_lb', type: 'uint8' },
      { internalType: 'uint8', name: '_rf', type: 'uint8' },
    ],
    name: 'init',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getLTV',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [],
    name: 'getLB',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [],
    name: 'getRF',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [
      { internalType: 'uint256', name: '_totalBorrow', type: 'uint256' },
      { internalType: 'uint256', name: '_availableBorrow', type: 'uint256' },
    ],
    name: 'getInterestRate',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [],
    name: 'getAvailableLiquidity0',
    outputs: [{ internalType: 'uint256', name: '_available', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [],
    name: 'getAvailableLiquidity1',
    outputs: [{ internalType: 'uint256', name: '_available', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [{ internalType: 'uint256', name: '_nftID', type: 'uint256' }],
    name: 'userHealthFactorLtv',
    outputs: [
      { internalType: 'uint256', name: '_healthFactor0', type: 'uint256' },
      { internalType: 'uint256', name: '_healthFactor1', type: 'uint256' },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [{ internalType: 'uint256', name: '_nftID', type: 'uint256' }],
    name: 'userHealthFactor',
    outputs: [
      { internalType: 'uint256', name: '_healthFactor0', type: 'uint256' },
      { internalType: 'uint256', name: '_healthFactor1', type: 'uint256' },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [{ internalType: 'uint256', name: '_nftID', type: 'uint256' }],
    name: 'userBalanceOftoken0',
    outputs: [
      { internalType: 'uint256', name: '_lendBalance0', type: 'uint256' },
      { internalType: 'uint256', name: '_borrowBalance0', type: 'uint256' },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [{ internalType: 'uint256', name: '_nftID', type: 'uint256' }],
    name: 'userBalanceOftoken1',
    outputs: [
      { internalType: 'uint256', name: '_lendBalance1', type: 'uint256' },
      { internalType: 'uint256', name: '_borrowBalance1', type: 'uint256' },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [{ internalType: 'uint256', name: '_nftID', type: 'uint256' }],
    name: 'userBalanceOftokens',
    outputs: [
      { internalType: 'uint256', name: '_lendBalance0', type: 'uint256' },
      { internalType: 'uint256', name: '_borrowBalance0', type: 'uint256' },
      { internalType: 'uint256', name: '_lendBalance1', type: 'uint256' },
      { internalType: 'uint256', name: '_borrowBalance1', type: 'uint256' },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [{ internalType: 'uint256', name: '_nftID', type: 'uint256' }],
    name: 'userSharesOftoken0',
    outputs: [
      { internalType: 'uint256', name: '_lendShare0', type: 'uint256' },
      { internalType: 'uint256', name: '_borrowShare0', type: 'uint256' },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [{ internalType: 'uint256', name: '_nftID', type: 'uint256' }],
    name: 'userSharesOftoken1',
    outputs: [
      { internalType: 'uint256', name: '_lendShare1', type: 'uint256' },
      { internalType: 'uint256', name: '_borrowShare1', type: 'uint256' },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [{ internalType: 'uint256', name: '_nftID', type: 'uint256' }],
    name: 'userSharesOftokens',
    outputs: [
      { internalType: 'uint256', name: '_lendShare0', type: 'uint256' },
      { internalType: 'uint256', name: '_borrowShare0', type: 'uint256' },
      { internalType: 'uint256', name: '_lendShare1', type: 'uint256' },
      { internalType: 'uint256', name: '_borrowShare1', type: 'uint256' },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [],
    name: 'poolData',
    outputs: [
      { internalType: 'uint256', name: '_totalLendShare0', type: 'uint256' },
      { internalType: 'uint256', name: '_totalBorrowShare0', type: 'uint256' },
      { internalType: 'uint256', name: '_totalBorrow0', type: 'uint256' },
      { internalType: 'uint256', name: '_totalBalance0', type: 'uint256' },
      {
        internalType: 'uint256',
        name: '_totalAvailableLiquidity0',
        type: 'uint256',
      },
      { internalType: 'uint256', name: '_totalLendShare1', type: 'uint256' },
      { internalType: 'uint256', name: '_totalBorrowShare1', type: 'uint256' },
      { internalType: 'uint256', name: '_totalBorrow1', type: 'uint256' },
      { internalType: 'uint256', name: '_totalBalance1', type: 'uint256' },
      {
        internalType: 'uint256',
        name: '_totalAvailableLiquidity1',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [{ internalType: 'address', name: '_address', type: 'address' }],
    name: 'setInterestRateAddress',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint8', name: '_number', type: 'uint8' }],
    name: 'setLTV',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint8', name: '_number', type: 'uint8' }],
    name: 'setLB',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint8', name: '_number', type: 'uint8' }],
    name: 'setRF',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'accrueInterest',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: '_receiver', type: 'address' },
      { internalType: 'int256', name: '_amount', type: 'int256' },
    ],
    name: 'processFlashLoan',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256', name: '_nftID', type: 'uint256' },
      { internalType: 'int256', name: 'amount', type: 'int256' },
    ],
    name: 'lend',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256', name: '_nftID', type: 'uint256' },
      { internalType: 'int256', name: 'tok_amount', type: 'int256' },
      { internalType: 'address', name: '_receiver', type: 'address' },
    ],
    name: 'redeem',
    outputs: [{ internalType: 'int256', name: '_amount', type: 'int256' }],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256', name: '_nftID', type: 'uint256' },
      { internalType: 'int256', name: '_amount', type: 'int256' },
      { internalType: 'address', name: '_receiver', type: 'address' },
    ],
    name: 'redeemUnderlying',
    outputs: [{ internalType: 'int256', name: 'rtAmount', type: 'int256' }],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256', name: '_nftID', type: 'uint256' },
      { internalType: 'int256', name: 'amount', type: 'int256' },
      { internalType: 'address payable', name: '_recipient', type: 'address' },
    ],
    name: 'borrow',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256', name: '_nftID', type: 'uint256' },
      { internalType: 'int256', name: 'amount', type: 'int256' },
      { internalType: 'address', name: '_payer', type: 'address' },
    ],
    name: 'repay',
    outputs: [{ internalType: 'int256', name: '_rAmount', type: 'int256' }],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256', name: '_nftID', type: 'uint256' },
      { internalType: 'int256', name: 'amount', type: 'int256' },
      { internalType: 'address', name: '_receiver', type: 'address' },
      { internalType: 'uint256', name: '_toNftID', type: 'uint256' },
    ],
    name: 'liquidate',
    outputs: [
      { internalType: 'int256', name: 'liquidatedAmount', type: 'int256' },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256[]', name: '_nftIDs', type: 'uint256[]' },
      { internalType: 'int256[]', name: 'amounts', type: 'int256[]' },
      { internalType: 'address', name: '_receiver', type: 'address' },
      { internalType: 'uint256', name: '_toNftID', type: 'uint256' },
    ],
    name: 'liquidateMulti',
    outputs: [
      { internalType: 'int256', name: 'liquidatedAmountTotal', type: 'int256' },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
];

export const unilendV2helperABI = [
  { inputs: [], stateMutability: 'nonpayable', type: 'constructor' },
  {
    inputs: [{ internalType: 'address', name: '_pool', type: 'address' }],
    name: 'getPoolData',
    outputs: [
      {
        components: [
          { internalType: 'uint256', name: 'ltv', type: 'uint256' },
          { internalType: 'uint256', name: 'lb', type: 'uint256' },
          { internalType: 'uint256', name: 'rf', type: 'uint256' },
          {
            internalType: 'uint256',
            name: '_token0Liquidity',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: '_token1Liquidity',
            type: 'uint256',
          },
          { internalType: 'address', name: '_core', type: 'address' },
          { internalType: 'address', name: '_token0', type: 'address' },
          { internalType: 'address', name: '_token1', type: 'address' },
          { internalType: 'string', name: '_symbol0', type: 'string' },
          { internalType: 'string', name: '_symbol1', type: 'string' },
          { internalType: 'uint256', name: '_decimals0', type: 'uint256' },
          { internalType: 'uint256', name: '_decimals1', type: 'uint256' },
        ],
        internalType: 'struct helper.outData',
        name: '_out',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: '_position', type: 'address' },
      { internalType: 'address', name: '_pool', type: 'address' },
      { internalType: 'address', name: '_user', type: 'address' },
    ],
    name: 'getPoolFullData',
    outputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: '_token0Liquidity',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: '_token1Liquidity',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: '_totalLendShare0',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: '_totalLendShare1',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: '_totalBorrowShare0',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: '_totalBorrowShare1',
            type: 'uint256',
          },
          { internalType: 'uint256', name: '_totalBorrow0', type: 'uint256' },
          { internalType: 'uint256', name: '_totalBorrow1', type: 'uint256' },
          { internalType: 'uint256', name: '_interest0', type: 'uint256' },
          { internalType: 'uint256', name: '_interest1', type: 'uint256' },
          { internalType: 'uint256', name: '_lendShare0', type: 'uint256' },
          { internalType: 'uint256', name: '_borrowShare0', type: 'uint256' },
          { internalType: 'uint256', name: '_lendShare1', type: 'uint256' },
          { internalType: 'uint256', name: '_borrowShare1', type: 'uint256' },
          { internalType: 'uint256', name: '_lendBalance0', type: 'uint256' },
          { internalType: 'uint256', name: '_borrowBalance0', type: 'uint256' },
          { internalType: 'uint256', name: '_lendBalance1', type: 'uint256' },
          { internalType: 'uint256', name: '_borrowBalance1', type: 'uint256' },
          { internalType: 'uint256', name: '_healthFactor0', type: 'uint256' },
          { internalType: 'uint256', name: '_healthFactor1', type: 'uint256' },
        ],
        internalType: 'struct helper.outDataFull',
        name: '_out',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: '_pool', type: 'address' },
      { internalType: 'address', name: '_user', type: 'address' },
    ],
    name: 'getPoolTokensData',
    outputs: [
      { internalType: 'uint256', name: '_allowance0', type: 'uint256' },
      { internalType: 'uint256', name: '_allowance1', type: 'uint256' },
      { internalType: 'uint256', name: '_balance0', type: 'uint256' },
      { internalType: 'uint256', name: '_balance1', type: 'uint256' },
    ],
    stateMutability: 'view',
    type: 'function',
  },
];

export const erc20ABI = [
  {
    constant: true,
    inputs: [],
    name: 'name',
    outputs: [{ name: '', type: 'string' }],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      { name: '_spender', type: 'address' },
      { name: '_value', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: '', type: 'bool' }],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: true,
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', type: 'uint256' }],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      { name: '_from', type: 'address' },
      { name: '_to', type: 'address' },
      { name: '_value', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [{ name: '', type: 'bool' }],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: true,
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', type: 'uint8' }],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: true,
    inputs: [{ name: '_owner', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: 'balance', type: 'uint256' }],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: true,
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', type: 'string' }],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      { name: '_to', type: 'address' },
      { name: '_value', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ name: '', type: 'bool' }],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: true,
    inputs: [
      { name: '_owner', type: 'address' },
      { name: '_spender', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: '', type: 'uint256' }],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  { payable: true, stateMutability: 'payable', type: 'fallback' },
  {
    anonymous: false,
    inputs: [
      { indexed: true, name: 'owner', type: 'address' },
      { indexed: true, name: 'spender', type: 'address' },
      { indexed: false, name: 'value', type: 'uint256' },
    ],
    name: 'Approval',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, name: 'from', type: 'address' },
      { indexed: true, name: 'to', type: 'address' },
      { indexed: false, name: 'value', type: 'uint256' },
    ],
    name: 'Transfer',
    type: 'event',
  },
];

export const PositionABI = [
  {
    inputs: [
      {
        internalType: 'address payable',
        name: '_core',
        type: 'address',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'approved',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'Approval',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'operator',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'bool',
        name: 'approved',
        type: 'bool',
      },
    ],
    name: 'ApprovalForAll',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'Transfer',
    type: 'event',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'approve',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
    ],
    name: 'balanceOf',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [],
    name: 'baseURI',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [],
    name: 'core',
    outputs: [
      {
        internalType: 'address payable',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'getApproved',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'operator',
        type: 'address',
      },
    ],
    name: 'isApprovedForAll',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [],
    name: 'name',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'ownerOf',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
      {
        internalType: 'bytes',
        name: '_data',
        type: 'bytes',
      },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'operator',
        type: 'address',
      },
      {
        internalType: 'bool',
        name: 'approved',
        type: 'bool',
      },
    ],
    name: 'setApprovalForAll',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes4',
        name: 'interfaceId',
        type: 'bytes4',
      },
    ],
    name: 'supportsInterface',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [],
    name: 'symbol',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'index',
        type: 'uint256',
      },
    ],
    name: 'tokenByIndex',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'index',
        type: 'uint256',
      },
    ],
    name: 'tokenOfOwnerByIndex',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'tokenURI',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [],
    name: 'totalSupply',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'transferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_pool',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_recipient',
        type: 'address',
      },
    ],
    name: 'newPosition',
    outputs: [
      {
        internalType: 'uint256',
        name: 'nftID',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_pool',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_user',
        type: 'address',
      },
    ],
    name: 'getNftId',
    outputs: [
      {
        internalType: 'uint256',
        name: 'nftID',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_nftID',
        type: 'uint256',
      },
    ],
    name: 'position',
    outputs: [
      {
        components: [
          {
            internalType: 'address',
            name: 'token0',
            type: 'address',
          },
          {
            internalType: 'address',
            name: 'token1',
            type: 'address',
          },
          {
            internalType: 'uint256',
            name: 'lendBalance0',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'borrowBalance0',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'lendBalance1',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'borrowBalance1',
            type: 'uint256',
          },
        ],
        internalType: 'struct UnilendV2Position.nftPositionData',
        name: '_positionData',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
];

export const oracleAbi = [
  {
    inputs: [
      {
        internalType: 'address',
        name: 'weth',
        type: 'address',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'asset',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'source',
        type: 'address',
      },
    ],
    name: 'AssetOracleUpdated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'OwnershipTransferred',
    type: 'event',
  },
  {
    inputs: [],
    name: 'WETH',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    name: 'aPrice',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'token0',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'token1',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'getAssetPrice',
    outputs: [
      {
        internalType: 'uint256',
        name: '_price',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'asset',
        type: 'address',
      },
    ],
    name: 'getChainLinkAssetPrice',
    outputs: [
      {
        internalType: 'int256',
        name: 'price',
        type: 'int256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'contract AggregatorV3Interface',
        name: 'priceFeed',
        type: 'address',
      },
    ],
    name: 'getLatestPrice',
    outputs: [
      {
        internalType: 'int256',
        name: '',
        type: 'int256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'token0',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'token1',
        type: 'address',
      },
    ],
    name: 'getUniswapV3Price',
    outputs: [
      {
        internalType: 'int256',
        name: '',
        type: 'int256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address[]',
        name: 'assets',
        type: 'address[]',
      },
      {
        internalType: 'address[]',
        name: 'sources',
        type: 'address[]',
      },
    ],
    name: 'setAssetOracles',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'token0',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'token1',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'price',
        type: 'uint256',
      },
    ],
    name: 'setTokenPrice',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'token0',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'token1',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'price',
        type: 'uint256',
      },
    ],
    name: 'setTokenPriceB',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
];
